import { axios } from './config';

export const getPlaylistConfig = (siteId) => {
	return axios.get(`/playlist/${siteId}`);
};

export const syncSingleConfig = (payload) => {
	return axios.post(`/playlist/sync-single`, payload);
};

export const syncBulkConfig = (payload) => {
	return axios.post(`/playlist/sync-bulk`, payload);
}

export const createConfig = (payload) => {
	return axios.post(`/playlist/create-config`, payload);
};

export const updateConfig = (payload) => {
	return axios.post(`/playlist/update-config`, payload);
};
